const testimonialData = [
  {
    name: 'Mescha Stevens',
    profile: 'MS',
    img: '/person1.png',
    content: 'Today was my second visit with Dr Dollie and I am so happy I found her. My first visit was for a tooth whereby the wall of the tooth broke off, and at today’s visit she filled 3 teeth in less than an hour. I’ve had terrible experiences with previous dentists and I’ve definitely found the one I’m sticking to. I am so happy! I had no discomfort whatsoever. She made me feel comfortable and at ease knowing how nervous I was. Dr Dollie is the best! I would definitely recommend her ❤️'
  },
  {
    name: 'Harold Volkwyn',
    profile: 'HW',
    img: '/person2.jpg',
    content: 'Very caring and professional service. Dr Dollie and her team give excellent service. 5 ⭐ indeed.'
  },
  {
    name: 'Roxanne Cerff',
    profile: 'RC',
    img: '/person3.png',
    content: 'Would highly recommend! 🦷Dr Dollie and staff has to be the most engaging I’ve ever experienced. They are extremely relatable and really calm your nerves. Dr Dollie provided proper advice and recommendations. Before starting she confirmed all that she’d be doing, during the procedure she kept checking in to ensure that I was comfortable and at ease. It was such a comforting journey.'
  }
];

export default testimonialData;
